import { CSSObject } from '@chakra-ui/react';

export const LinkWrapper: CSSObject = {
  bg: 'rgba(34, 92, 161, 0.5)',
  boxShadow:
    '0px 4px 8px 0px rgba(0, 0, 0, 0.25), 0px 0px 20px 0px rgba(0, 216, 255, 0.15) inset, 0px 0px 0px 1px rgba(149, 239, 255, 0.2) inset',
  backdropFilter: 'blur(8px)',
  borderRadius: 'md',
  fontFamily: 'body',
  fontSize: 'sm',
  fontWeight: 'bold',
  border: 'none',
  px: '2',
  py: '4',
  mb: '2',
  color: 'white',
  _hover: {
    bg: 'alpha.500',
    color: 'white',
  },
  _focus: {
    bg: 'alpha.500',
    color: 'white',
  },
  _last: {
    mb: '1',
  },
};
